module.exports = __webpack_public_path__ + "static/media/us-img.f9595a45.jpg";